import { SagaIterator } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { Produktlinienname } from '@ps20/bff-models';
import {
  GlobalAction,
  GlobalActions,
  MasterProduktData,
} from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { TkvActions } from '../tkvActions';
import { selectProduktlinien } from '../../app/shared/selectors/produkt.selector';
import { IAppState } from '../appState';

export function* watchProduktlinienSaga(): SagaIterator {
  yield takeLatest(TkvActions.IN_BEHANDLUNG_CHANGED, safeSaga(updateProduktlinienStatus, App.TKV));
  yield takeLatest(TkvActions.BEHANDLUNGEN_CHANGED, safeSaga(updateProduktlinienStatus, App.TKV));
  yield takeLatest(
    TkvActions.ANZAHL_OPERATIONEN_CHANGED,
    safeSaga(updateProduktlinienStatus, App.TKV),
  );
  yield takeLatest(
    GlobalActions.PRODUKT_RECEIVED,
    safeSaga(updateProduktlinienStatusOnProductReceived, App.TKV),
  );
}

export function* updateProduktlinienStatusOnProductReceived(
  action: GlobalAction<MasterProduktData>,
): SagaIterator {
  const { appId, angebotsId } = action.payload;
  const state: IAppState = yield select();
  if (appId === App.TKV && angebotsId === state.angebotsId) {
    yield call(updateProduktlinienStatus);
  }
}

export function* updateProduktlinienStatus(): SagaIterator {
  const produktlinien = yield select(selectProduktlinien);

  updateSelectedProduktlinie(produktlinien);
  const changeProduktlinienAction = new TkvActions().produktlinienChanged(produktlinien);
  yield put(changeProduktlinienAction);
}

function updateSelectedProduktlinie(produktlinien: Produktlinie[]) {
  const selectedProduktline = produktlinien.find(
    produktlinie => !produktlinie.deactivated && produktlinie.selected,
  );

  if (selectedProduktline == null) {
    const activatedProduktlinien = produktlinien.filter(produktlinie => !produktlinie.deactivated);
    const produktlinieToActivate = activatedProduktlinien.find(
      produktlinie => produktlinie.produktName === Produktlinienname.KOMFORT,
    );
    produktlinieToActivate.selected = true;
  }
}
